import { render, staticRenderFns } from "./x_ray.vue?vue&type=template&id=cb2cb09a&scoped=true"
import script from "./x_ray.vue?vue&type=script&lang=js"
export * from "./x_ray.vue?vue&type=script&lang=js"
import style0 from "./x_ray.vue?vue&type=style&index=0&id=cb2cb09a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2cb09a",
  null
  
)

export default component.exports